import "./Profil.css";
import React from "react";
import { Link } from "react-router-dom";
import { MODIFIER_PROFIL } from "../../../Routes/NAVIGATION_PATH";
import { Container, Row, Col } from 'react-bootstrap';
import tof3 from '../../../Assets/imge/istockphoto-1270067126-612x612.jpg';
import Table from 'react-bootstrap/Table';
function template() {
  return (
    <div className="profil">
      <div className="profile p">
        <h2 className="text-uppercase ps-3">Informations Generaux</h2>
        <div className="" style={{ background: '#FFF' }}>

          <Container fluid >
            <Row className="py-5 mx-0">
              <Col lg={4} className="text-center blocProfil">
                
                <img src={tof3} alt='tof3' className="imgprofil" />

                <div className="vvd">

                  <span className="textsapn">Babacar sall</span> <br />
                  <span className="textsapn"  >Admin</span><br />


                  <Link to={MODIFIER_PROFIL} variant="primary" className="btnn btn btn-md"><span style={{ color: 'white' }}>Modifer Profile</span></Link>
                </div>
              </Col>
              <Col lg={8} className="ps-5">

                <Table responsive className="tabl ps-5" >

                  <tbody>
                    <br />
                    <tr className="info">
                      <td colSpan={3} className='info' ><span style={{ color: 'white' }}>Information Generaux</span></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colSpan={3}>Prenom</td>

                      <td>Babacar</td>
                    </tr>

                    <tr>
                      <td colSpan={3}>Nom</td>
                      <td>Sall</td>
                    </tr>
                    <tr>
                      <td colSpan={3}>Statu</td>
                      <td>Administrateur</td>
                    </tr>
                    <tr>
                      <td colSpan={3}>E-mail</td>
                      <td>Babacar527@gmail.com</td>
                    </tr>
                    <tr className='info'>
                      <td colSpan={3} ><span style={{ color: 'white' }}>Statistique</span></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colSpan={3}>Nomber de member ajoutes</td>
                      <td>25</td>
                    </tr>
                    <tr>
                      <td colSpan={3}>Nomber de member archives</td>
                      <td>10</td>
                    </tr>

                    <tr>
                      <td colSpan={3}>Nomber de member bloques</td>
                      <td>4</td>
                    </tr>

                  </tbody>
                </Table>
              </Col>
             
            </Row>

          </Container>

        </div>
      </div>
    </div>
  );
};

export default template;
